@switch (Scope.paymentProcessor!.Type) {
    @case (PaymentProcessorType.PayPalPro) {
        <lib-payment-sources-add-paypal-pro data-clarity-mask="true"></lib-payment-sources-add-paypal-pro>
    }
    @case (PaymentProcessorType.Stripe) {
        <lib-payment-sources-add-stripe data-clarity-mask="true"></lib-payment-sources-add-stripe>
    }
    @case (PaymentProcessorType.PayPalCommercePlatform) {
        <lib-payment-sources-add-paypal data-clarity-mask="true"></lib-payment-sources-add-paypal>
    }
}
